import { css } from '@emotion/css';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

export const switcherWrapper = css`
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const promoCard = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(${SpacingToken.Spacing2});
  padding: var(${SpacingToken.Spacing4});
  border-radius: var(${RadiusToken.Radius4});
  background-color: var(${DesignToken.SurfacePrimaryDefault});
  box-shadow: var(--shadow-float);
`;

export const promoTitle = css`
  margin: 0;
`;

export const promoCta = css`
  margin-top: var(${SpacingToken.Spacing2});
`;
